import { FC, ReactElement, useRef, useState, MouseEvent } from 'react';
import { Icon } from '../../UI/Icon/Icon';
import AvisoArquivarObra from 'Pages/Obras/Modals/AvisoArquivarObra';
import { useDispatch } from 'react-redux';
import { ObraActions } from 'Store/Obra/Obra.actions';
import { IArchivedStatusRequest } from 'Data/interfaces/Obra/IArchivedStatusRequest';
import AccessPermission from 'Utils/AcessPermission';
import { IContextMenuRef } from '../ContextMenu/model';
import ContextMenu from '../ContextMenu';
import { ContextMenuItem } from '../ContextMenu/styles';

interface IActionMenuItem {
  children: ReactElement;
  constructionSiteId: number;
  constructionSiteName?: string;
  activeObrasCount?: number;
  openInviteUser: () => void;
}

const ActionMenuItem: FC<IActionMenuItem> = ({
  constructionSiteId,
  children,
  constructionSiteName,
  activeObrasCount,
  openInviteUser,
}) => {
  const dispatch = useDispatch();

  const contextMenuRef = useRef<IContextMenuRef>(null);
  const [arquivarObraVisible, setArquivarObraVisible] = useState(false);
  const menuId = `ActionMenuObra${constructionSiteId}`;

  const handleContextMenu = (e: MouseEvent) => {
    if (!AccessPermission.isAdmin() && !AccessPermission.isCoordenador()) {
      return;
    };

    contextMenuRef.current?.show(e);
  };

  const arquivarObra = () => {
    const status: IArchivedStatusRequest = {
      ConstructionSiteId: constructionSiteId,
      isArchived: true,
    };
    dispatch(ObraActions.updateArchivedStatus(status));
    if (activeObrasCount && activeObrasCount === 1) {
      dispatch(ObraActions.clearConstructionSiteSearch(true));
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div onContextMenu={handleContextMenu}>
        {children}
      </div>

      <ContextMenu ref={contextMenuRef} id={menuId} menuHeight={80} menuWidth={156.27}>
        <ContextMenuItem onClick={openInviteUser}>
          <Icon icon='adicionarUsuario' customColor='#44566C' size='xs' />
          <span>Adicionar colaborador</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={() => setArquivarObraVisible(true)}>
          <Icon icon='arquivar' customColor='#44566C' size='xs' />
          <span>Arquivar</span>
        </ContextMenuItem>
      </ContextMenu>

      <AvisoArquivarObra
        nomeObra={constructionSiteName}
        visible={arquivarObraVisible}
        onCancel={() => setArquivarObraVisible(false)}
        onConfirm={arquivarObra}
      />
    </div>
  );
};

export default ActionMenuItem;
